var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOffline)?_c('div',{staticClass:"offline",style:({
      top: ((this.$store.get('systems@PageHeight') - 26) + "px"),
      width: ((this.$store.get('systems@PageWidth') - 0) + "px")
    })},[_vm._v("\n    App is offline (กรุณาตรวจสอบการเชื่อมต่อระบบ)\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }